import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthUser } from "../../../../globalTypes/auth.types";
import { environment } from "../../../environments/environment";
import { segmentLogic } from "../../../../globalTypes/_segmentLogic";
import { _EMAIL_ADDRESS_FOR_TESTING_SUCCESSFULLY_SEGMENT_VERIFIED } from "../../../../globalTypes/account.types";

export interface TestReturn {
  success: boolean,
  failureMsg?: string,
  successMsg?: string,
}

export const preRegRequirementsTests: { [key: string]: (user: AuthUser | {email: string}, snackBar: MatSnackBar) => TestReturn } = {
  ActivateChickFilAUser: (user: AuthUser | {email: string}, snackBar:MatSnackBar): TestReturn=>{
    let success = segmentLogic.ActivateChickFilAUser(user.email);
    if(!environment.production && _EMAIL_ADDRESS_FOR_TESTING_SUCCESSFULLY_SEGMENT_VERIFIED === user.email){
      snackBar.open("TEST MODE Pre-registration requirement: "+(success ? "Passed" : "Failed - Not @chick-fil-a.com, but also not fail@test.com, so we'll let it slide."), "Close", {duration: 10000});
      success = true; // override for testing purposes
    }
    return { 
      success, 
      successMsg: "Successful Chick-fil-A signup",
      // failureMsg: "Please sign up with your Chick-fil-A email address"
    }
  }
}